import { render, staticRenderFns } from "./document-preview-pdf.vue?vue&type=template&id=6e748542&scoped=true&"
import script from "./document-preview-pdf.vue?vue&type=script&lang=js&"
export * from "./document-preview-pdf.vue?vue&type=script&lang=js&"
import style0 from "./document-preview-pdf.vue?vue&type=style&index=0&id=6e748542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e748542",
  null
  
)

export default component.exports